var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06967 1.61836V6.53779V12.6894V22.3771C5.06967 22.7206 4.79485 22.9954 4.45131 22.9954C4.10778 22.9954 3.83295 22.7206 3.83295 22.3771V12.6939V6.53779V1.61836C3.83295 1.27483 4.10778 1 4.45131 1C4.79485 1 5.06967 1.27483 5.06967 1.61836Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12C3.12048 12 2 10.8795 2 9.5C2 8.12048 3.12048 7 4.5 7C5.87952 7 7 8.12048 7 9.5C7 10.8795 5.87349 12 4.5 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5697 1.61836V6.53779V12.6894V22.3771C12.5697 22.7206 12.2948 22.9954 11.9513 22.9954C11.6078 22.9954 11.3329 22.7206 11.3329 22.3771V12.6939V6.53779V1.61836C11.3329 1.27483 11.6078 1 11.9513 1C12.2948 1 12.5697 1.27483 12.5697 1.61836Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7676C10.6205 17.7676 9.5 16.6471 9.5 15.2676C9.5 13.8881 10.6205 12.7676 12 12.7676C13.3795 12.7676 14.5 13.8881 14.5 15.2676C14.5 16.6471 13.3735 17.7676 12 17.7676Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0697 1.61836V6.53779V12.6894V22.3771C20.0697 22.7206 19.7948 22.9954 19.4513 22.9954C19.1078 22.9954 18.8329 22.7206 18.8329 22.3771V12.6939V6.53779V1.61836C18.8329 1.27483 19.1078 1 19.4513 1C19.7948 1 20.0697 1.27483 20.0697 1.61836Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C18.1205 12 17 10.8795 17 9.5C17 8.12048 18.1205 7 19.5 7C20.8795 7 22 8.12048 22 9.5C22 10.8795 20.8735 12 19.5 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.cee1ef11e500eb2f8602f2d87d478e9d.svg";
export { ForwardRef as ReactComponent };